// extracted by mini-css-extract-plugin
module.exports = {"container":"TextSectionElement_container__3qg6q","defaultText":"TextSectionElement_defaultText__2UgSe","textContent":"TextSectionElement_textContent__1mP0y"};